module.exports = __webpack_public_path__ + "static/media/tech-holistic-1.0e26371a.png";